module.exports = __webpack_public_path__ + "static/media/PD-logo.055932a0.svg";